import React from 'react';
import { ExternalUrlContainer } from './externalUrlStyles';
import { IonIcon } from '@ionic/react';
import { link } from 'ionicons/icons';

type ExternalUrlProps = {
	url: string;
	description: string;
};

const isSafeUrl = (u: string): boolean => {
	try {
		const parsed = new URL(u);
		return parsed.protocol === 'http:' || parsed.protocol === 'https:';
	} catch {
		return false;
	}
};

const ExternalUrl: React.FC<ExternalUrlProps> = ({ url, description }) => {
	if (!isSafeUrl(url)) {
		return null;
	}
	return (
		<ExternalUrlContainer>
			<div>
				<h4>More to discover&hellip;</h4>
				<p>{description}</p>
				<a href={url} target="_blank" rel="noopener noreferrer">
					Visit website <IonIcon icon={link} />
				</a>
				<p>
					<em>Opens in your web browser</em>
				</p>
			</div>
		</ExternalUrlContainer>
	);
};

export default ExternalUrl;
